import { httpCreate } from './http';
import config from './config';

const http = httpCreate('/um/fission-wechat');

export const fissionWechat = {
	/** 获取小程序码
	 * @param { Number } groupId 详情
	 * @param { String } params.env 小程序环境  正式版为 release，体验版为 trial，开发版为 develop
	 * @param { Number } params.width 二维码的宽度，单位px，最小 280，最大 1280
	 * @returns
	 */
	getWeappCode(groupId, params) {
		// return http.get(`/qr-code/${groupId}`, { params });
		const queryStr = new URLSearchParams(params).toString();
		return `${config.host}/um/fission-wechat/qr-code/${groupId}${queryStr ? '?' + queryStr : ''}`;
	},
};
